// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"c8c5a458","166":"8007856f","195":"dd812db4","233":"2eff9f8a","335":"d87a6e30","376":"3f64fa13","507":"8122f246","582":"8122f246","745":"8122f246","987":"8007856f"}[chunkId] + ".chunk.css";
};